import { render, staticRenderFns } from "./importPrivileges.vue?vue&type=template&id=59c82fd0&scoped=true"
import script from "./importPrivileges.vue?vue&type=script&lang=js"
export * from "./importPrivileges.vue?vue&type=script&lang=js"
import style0 from "./importPrivileges.vue?vue&type=style&index=0&id=59c82fd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c82fd0",
  null
  
)

export default component.exports